import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Text from '../../Common/Form/Text';
import Continue from '../../Common/Continue';
import { Input } from '../../ui';
import { validateEmail } from '../../../helpers';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconUser from '../../../assets/icons/icon-user.svg';
import { setHealthValue } from '../../../actions';
import { useContinue } from './useContinue';

const SaludWrapper = styled.div`
  .SaludForm {
    &-question {
      margin-bottom: 0;
      color: var(--text-color-2);
    }

    &-container {
      max-width: 450px;
      margin-left: auto;
      margin-right: auto;
    }

    &-label {
      color: var(--text-color-2);
      padding-top: 25px;
    }
  }
`;

const SaludForm1 = ({ personName, personEmail, onValueChange }) => {
  const isValidForm = useContinue(
    personName !== '' && personEmail !== '' && validateEmail(personEmail)
  );

  return (
    <SaludWrapper>
      <Text className="SaludForm-question">
        Comencemos por saber un poco de vos
      </Text>

      <div className="SaludForm-container">
        <Text className="SaludForm-label">¿Cómo te llamás?</Text>

        <Input
          id="personName"
          type="text"
          value={personName}
          leftIcon={iconUser}
          onChange={event => onValueChange('personName', event.target.value)}
        />

        <Text className="SaludForm-label">
          ¿Cuál es tu dirección de e-mail?
        </Text>

        <Input
          id="personEmail"
          value={personEmail}
          type="email"
          leftIcon={iconEmail}
          onChange={event => onValueChange('personEmail', event.target.value)}
        />
      </div>

      <Continue state={isValidForm} />
    </SaludWrapper>
  );
};

const mapStateToProps = state => {
  return {
    personName: state.health.personName,
    personEmail: state.health.personEmail
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onValueChange: (type, value) => {
      dispatch(setHealthValue(type, value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SaludForm1);
